document.addEventListener('DOMContentLoaded', () => {
    // custom-testimonials section
    Array.from(document.querySelectorAll('.custom-testimonials__avatars li .mask')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.section__custom-testimonials__container');
            container.querySelector('.custom-testimonials__block.active').classList.remove('active');
            container.querySelector('.custom-testimonials__block[js-data-target="'+element.getAttribute('js-data-target')+'"]').classList.add('active');
        });
    });

    // custom-video section
    Array.from(document.querySelectorAll('[js-video-pause]')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.section__custom-video__container');
            container.querySelector('video').pause();
            container.querySelector('[js-video-play]').style.display = 'flex';
            element.style.display = 'none';
        });
    });
    Array.from(document.querySelectorAll('[js-video-play]')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.section__custom-video__container');
            container.querySelector('video').play();
            container.querySelector('[js-video-pause]').style.display = 'flex';
            element.style.display = 'none';
        });
    });

    // custom-benefits section
    Array.from(document.querySelectorAll('.section__custom-benefits__container .arrow-button')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.section__custom-benefits__container');
            const scrollContainer = container.querySelector('ul');
            let scrollLeft = scrollContainer.scrollLeft;
            const scrollWidth = scrollContainer.scrollWidth;
            const scrollUnit = scrollContainer.querySelector('li').clientWidth + 30;
            if (element.getAttribute('js-arrow-data') == 'left') {
                scrollLeft = (scrollLeft - scrollUnit < 0) ? 0 : (scrollLeft - scrollUnit);
                scrollContainer.scroll(scrollLeft, 0);
                container.querySelector('[js-arrow-data="right"]').classList.remove('disabled');
                if (scrollLeft == 0) {
                    element.classList.add('disabled');
                }
            }
            if (element.getAttribute('js-arrow-data') == 'right') {
                scrollLeft = ((scrollLeft + scrollUnit + scrollContainer.clientWidth) > scrollWidth) ? (scrollWidth - scrollContainer.clientWidth) : (scrollLeft + scrollUnit);
                scrollContainer.scroll(scrollLeft, 0);
                container.querySelector('[js-arrow-data="left"]').classList.remove('disabled');
                if (scrollLeft == (scrollWidth - scrollContainer.clientWidth)) {
                    element.classList.add('disabled');
                }
            }
        });
    });
    Array.from(document.querySelectorAll('.section__custom-benefits__container > ul')).forEach((element) => {
        element.addEventListener('touchmove', (e) => {
            e.preventDefault();
        });
    });

    // new-modal snippet
	// Array.from(document.querySelectorAll('.new-modal--container')).forEach((modal) => {
	// 	if (modal.querySelector('.new-modal--body').offsetHeight >= window.innerHeight) {
	// 		modal.querySelector('.new-modal--body').classList.add('over');
	// 		modal.querySelector('[js-body]').style.height = modal.querySelector('.new-modal--body').offsetHeight + 100 + 'px';
	// 		modal.querySelector('[js-mask]').style.height = modal.querySelector('.new-modal--body').offsetHeight + 100 + 'px';
	// 	}
	// });
    Array.from(document.querySelectorAll('[js-modal-shooter]')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('[js-new-modal-group]');
            const modal = container.querySelector('.new-modal--container[js-data-id="'+element.getAttribute('js-data-id')+'"]');
			modal.classList.add('open');
            document.querySelector('html').style.overflow = 'hidden';
            document.querySelector('main').style.zIndex = '9999';
        });
    });
    Array.from(document.querySelectorAll('.new-modal--container .mask')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.new-modal--container');
            container.classList.remove('open');
			container.scrollTo(0, 0);
            document.querySelector('html').style.overflow = 'auto';
            document.querySelector('main').style.zIndex = '1';
        });
    });
    Array.from(document.querySelectorAll('.new-modal--container [js-close]')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.new-modal--container');
            container.classList.remove('open');
			container.scrollTo(0, 0);
            document.querySelector('html').style.overflow = 'auto';
            document.querySelector('main').style.zIndex = '1';
        });
    });

    // product desktop carousel
    Array.from(document.querySelectorAll('.desktop-carousel--buttons [js-data-right]')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.product__media-container');
            const nextElement = container.querySelector('.product__media-item:not(.hidden) + .product__media-item');
            if (nextElement) {
                container.querySelector('.product__media.active [js-data-left]').classList.remove('disabled');
                container.querySelector('.product__media-item:not(.hidden)').classList.add('hidden');
                nextElement.classList.remove('hidden');
                const scrollStatusBar = container.querySelector('.small-hide[js-product-carouse-scroll-status-bar]');
								document.querySelectorAll('.insole-pack').forEach(insolePack => {
									insolePack.classList.add('hidden');
								});
                scrollStatusBar.setAttribute('js-data-index', parseInt(scrollStatusBar.getAttribute('js-data-index'))+1);
                scrollStatusBar.style.width = (100 * parseFloat(scrollStatusBar.getAttribute('js-data-index')) / parseFloat(scrollStatusBar.getAttribute('js-data-total'))) + '%';
                if (!container.querySelector('.product__media-item:not(.hidden) + .product__media-item')) {
                    element.classList.add('disabled')
                }
            }
        });
    });
    Array.from(document.querySelectorAll('.desktop-carousel--buttons [js-data-left]')).forEach((element) => {
        element.addEventListener('click', () => {
            const container = element.closest('.product__media-container');
            const previousElement = container.querySelector('.product__media-item:not(.hidden)').previousElementSibling;
            if (previousElement) {
                container.querySelector('[js-data-right]').classList.remove('disabled');
                container.querySelector('.product__media-item:not(.hidden)').classList.add('hidden');
                previousElement.classList.remove('hidden');
                const scrollStatusBar = container.querySelector('.small-hide[js-product-carouse-scroll-status-bar]');
								document.querySelectorAll('.insole-pack').forEach(insolePack => {
									if (parseInt(scrollStatusBar.getAttribute('js-data-index'))-1 == 1) {
										insolePack.classList.remove('hidden');
									} else {
										insolePack.classList.add('hidden');
									}
								});
                scrollStatusBar.setAttribute('js-data-index', parseInt(scrollStatusBar.getAttribute('js-data-index'))-1);
                scrollStatusBar.style.width = (100 * parseFloat(scrollStatusBar.getAttribute('js-data-index')) / parseFloat(scrollStatusBar.getAttribute('js-data-total'))) + '%';
                if (previousElement.previousElementSibling == null) {
                    element.classList.add('disabled')
                }
            }
        });
    });

    Array.from(document.querySelectorAll('.floating-scroll')).forEach((floatingElement) => {
        const { top, height } = floatingElement.getBoundingClientRect();
        if (elementIsVisibleInViewport(floatingElement)) {
            floatingElement.style.top = ((top >= 0) ? (-1) : 1) * (top + height / 2 - window.innerHeight / 2) / 10 + 'px';
        } else {
            floatingElement.style.top = ((top >= 0) ? (-1) : 1) * (window.innerHeight / 2 + height / 2) / 10 + 'px';
        }
    });
});

// document.addEventListener('scroll', function() {
//     Array.from(document.querySelectorAll('.floating-scroll')).forEach((floatingElement) => {
//         floatingElement.classList.remove('floating-down');
//         floatingElement.classList.remove('pause');
//         floatingElement.classList.add('floating');
    
//         clearTimeout(window.scrollTimeout);
//         window.scrollTimeout = setTimeout(() => {
//             floatingElement.classList.add('pause');
//         }, 100);
//     });
// });

const elementIsVisibleInViewport = (el, partiallyVisible = true) => {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
    (bottom > 0 && bottom < innerHeight) || (top <= 0 && bottom >= innerHeight)) &&
    ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

var lastScrollTop = 0;

document.addEventListener("scroll", function(){
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
    } else if (st < lastScrollTop) {
    }
    
    Array.from(document.querySelectorAll('.floating-scroll')).forEach((floatingElement) => {
        if (elementIsVisibleInViewport(floatingElement)) {
            let top = 0;
            if (floatingElement.style.top != '') {
                top = parseFloat(floatingElement.style.top);
            }
            let temp = 0;
            if (lastScrollTop != 0) {
                temp = st - lastScrollTop;
            }
            floatingElement.style.top = top + temp/10.0 + 'px';
        } else {
            const { top, height } = floatingElement.getBoundingClientRect();
            floatingElement.style.top = ((top >= 0) ? (-1) : 1) * (window.innerHeight / 2 + height / 2) / 10 + 'px';
        }
    });

    lastScrollTop = st <= 0 ? 0 : st;
}, false);